import apiClient from "../api/client";

export async function uploadMp3Chunks2(file: File) {
  const chunkSize = 5 * 1024 * 1024;
  const totalChunks = Math.ceil(file.size / chunkSize);
  const fileId = crypto.randomUUID();

  let finalFilePath = "";

  for (let i = 0; i < totalChunks; i++) {
    const blob = file.slice(i * chunkSize, (i + 1) * chunkSize);

    const form = new FormData();
    form.append("file", blob);
    form.append("fileId", fileId);
    form.append("chunkIndex", String(i));
    form.append("totalChunks", String(totalChunks));
    form.append("originalName", file.name);

    // const res = await fetch("/api/upload/chunk", {
    //   method: "POST",
    //   body: form,
    //   credentials: "include",
    // });

    const {data} = await apiClient.post(`/stream/upload-chunk`, form)

    if (!data.success) throw new Error(data.message);

    // last chunk response contains filePath
    if (data.filePath) {
      finalFilePath = data.filePath;
    }
  }

  return finalFilePath;
}

type ProgressFn = (percent: number) => void;

export async function uploadMp3Chunks(
  file: File,
  onProgress?: ProgressFn
) {
  const chunkSize = 5 * 1024 * 1024; // 5MB
  const totalChunks = Math.ceil(file.size / chunkSize);
  const fileId = crypto.randomUUID();

  let finalFilePath = "";

  console.log({chunkSize, totalChunks, fileId})

  for (let i = 0; i < totalChunks; i++) {
    const blob = file.slice(i * chunkSize, (i + 1) * chunkSize);
    console.log({blob})

    const form = new FormData();
    form.append("file", blob, file.name);
    form.append("fileId", fileId);
    form.append("chunkIndex", String(i));
    form.append("totalChunks", String(totalChunks));
    form.append("originalName", file.name);
    form.append("fileSize", String(file.size));

    console.log(Object.fromEntries(form.entries()));

    const res = await fetch(`${import.meta.env.VITE_API_BASE_URL}/stream/upload-chunk`, {
      method: "POST",
      body: form,
      credentials: "include",
    });

    // const {data} = await apiClient.post(`/stream/upload-chunk`, form, { headers: { "Content-Type": "multipart/form-data" } })

    const data = await res.json();
    if (!data.success) throw new Error(data.message);

    if (data.filePath) finalFilePath = data.filePath;

    // ✅ progress update
    if (onProgress) {
      const percent = Math.round(((i + 1) / totalChunks) * 100);
      onProgress(percent);
    }
  }

  return finalFilePath;
}
